import { render, staticRenderFns } from "./addApprovedDialog.vue?vue&type=template&id=75c807f6&scoped=true"
import script from "./addApprovedDialog.vue?vue&type=script&lang=js"
export * from "./addApprovedDialog.vue?vue&type=script&lang=js"
import style0 from "./addApprovedDialog.vue?vue&type=style&index=0&id=75c807f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c807f6",
  null
  
)

export default component.exports